export default "__VITE_ASSET__$gyD55wA__"